<template>
    <div class="form-group" ref="asdf">
        <label :for="name" v-text="label"></label>
        <multiselect :value="transformedValues"
                     @input="changed"
                     :name="name"
                     :options="options"
                     :multiple="multiple"
                     :close-on-select="!multiple"
                     :clear-on-select="!multiple"
                     :hide-selected="false"
                     :preserve-search="true"
                     placeholder=""
                     :custom-label="customLabel" 
                     :track-by="valueProperty" :loading="options.length === 0" :preselect-first="true">
        </multiselect>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  // OR register locally
  props: {
    entity: String,
    label: String,
    value: null,
    name: String,
    valueProperty: {
      type: String,
      default: "id"
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  components: { Multiselect },
  data() {
    return {
      options: [],
      values: this.value
    };
  },
  created() {
    let promises = [];
    axios
      .get("/api/" + store.state.language + "/" + this.entity + "/list")
      .then(({ data }) => {
        this.options = data.result;
      });
  },
  methods: {
    customLabel({ name }) {
      return name.text;
    },
    changed(value) {
      if(!this.multiple) {
        this.values = value[this.valueProperty];
        this.$emit("input", this.values);
        return;
      }

      this.values = [];
      for (let o of value) {
        this.values.push(o[this.valueProperty]);
      }
      this.$emit("input", this.values);
    }
  },
  computed: {
    transformedValues() {
      if (!this.multiple)
        return this.options.find(
          option => option[this.valueProperty] === this.values
        );

      if (this.options.length === 0) return [];
      let transformedValues = [];
      for (let o of this.options) {
        if (this.values.includes(o[this.valueProperty]))
          transformedValues.push(o);
      }
      return transformedValues;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EntityMultiselect.vue